import { systemConfig, loadSystemConfig, marketEnabled } from '@/utils/systemConfig'
export default {
  computed: {
    tradeServicesReady() { return systemConfig.ready },
    tradingAllowed() { return marketEnabled(this.stock.code.startsWith('hk') ? 'hk' : 'us') }
  },
  mounted() { this.loadTradeServices() },
  methods: { loadTradeServices() { return loadSystemConfig().catch(() => {}) } }
}
